import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DOTS = [0, 1, 2, 3, 4];

const ThreeDots = ({ index, setIndex }) => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleSelect = (dot) => {
    setIndex(dot);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <>
      {DOTS.map((dotIndex) => {
        const choosen = dotIndex === index;
        return (
          <div
            className={`h-[8px] w-[8px] cursor-pointer rounded-full ${choosen ? "bg-blue-700" : "bg-gray-300"}`}
            key={dotIndex}
            onClick={() => handleSelect(dotIndex)}
          />
        );
      })}
    </>
  );
};
export default ThreeDots;
